let ROOT_URL_EXPORT;
if(window.location.host == "localhost:8080") {
    ROOT_URL_EXPORT = 'http://api.language.test.4-com.pro';
    // ROOT_URL_EXPORT = 'http://api.speakly.me';
}else{
    if(window.location.host == "admin.language.dev.4-com.pro" || window.location.host == "admin.language.test.4-com.pro"){
        ROOT_URL_EXPORT = 'http://api.language.test.4-com.pro';
    }else{
        ROOT_URL_EXPORT = 'https://api.speakly.me';
    }
}

if (window.location.host == 'admin.speakly.test') {
    ROOT_URL_EXPORT = 'https://api.speakly.dev';
}
if (window.location.host == 'admin.speakly.localhost') {
    ROOT_URL_EXPORT = 'http://api.speakly.localhost';
}
export let ROOT_URL = ROOT_URL_EXPORT;
export const SIGN_IN = 'SIGN_IN';
export const GETUSER = 'GETUSER';
export const GETALLUSER = 'GETALLUSER';
export const GETUSERFILTER = 'GETUSERFILTER';
export const GETINFOONEUSER = 'GETINFOONEUSER';
export const EDITUSER = 'EDITUSER';
export const DASHBOARD = 'DASHBOARD';
export const GETADMIN = 'GETADMIN';
export const GETADMINONE = 'GETADMINONE';
export const EDITADMIN = 'EDITADMIN';
export const ADDADMIN = 'ADDADMIN';
export const TOGGLEADMIN = 'TOGGLEADMIN';
export const DELADMIN = 'DELADMIN';
export const GETLANGUAGE = 'GETLANGUAGE';
export const GETALLLANGUAGE = 'GETALLLANGUAGE';
export const GETONELANGUAGE = 'GETONELANGUAGE';
export const GETONELEARNINGLANGUAGE = 'GETONELEARNINGLANGUAGE';
export const ADDLANG = 'ADDLANG';
export const EDITLANG = 'EDITLANG';
export const GETFORINGLANGUAGE = 'GETFORINGLANGUAGE';
export const GETINTERFACELANGUAGE = 'GETINTERFACELANGUAGE';
export const GETONEINTERFACELANGUAGE = 'GETONEINTERFACELANGUAGE';
export const GETLEARNINGSTATS = 'GETLEARNINGSTATS';
export const EDITLEARNINGLANGUAGE = 'EDITLEARNINGLANGUAGE';
export const GETSTATSCHAT = 'GETSTATSCHAT';
export const ADDCHATPERSON = 'ADDCHATPERSON';
export const EDITCHATPERSON = 'EDITCHATPERSON';
export const GETCHATPERSON = 'GETCHATPERSON';
export const GETCHATPERSONONE = 'GETCHATPERSONONE';
export const GETSUBSCRIPTION = 'GETSUBSCRIPTION';
export const GETPACKAGES = 'GETPACKAGES';
export const GETPACKAGEONE = 'GETPACKAGEONE';
export const ADDPACKAGE = 'ADDPACKAGE';
export const EDITPACKAGE = 'EDITPACKAGE';
export const DELPACKAGE = 'DELPACKAGE';
export const GETCOUPON = 'GETCOUPON';
export const GETCOUPONONE = 'GETCOUPONONE';
export const DELCOUPON = 'DELCOUPON';
export const ADDCOUPON = 'ADDCOUPON';
export const EDITCOUPON = 'EDITCOUPON';
export const DELCHATPERSON = 'DELCHATPERSON';
export const SAVEWORD = 'SAVEWORD';
export const SAVEWORDEDIT = 'SAVEWORDEDIT';
export const GETWORD = 'GETWORD';
export const GETDETAILWORD = 'GETDETAILWORD';
export const DELWORD = 'DELWORD';
export const DELANGUAGE = 'DELANGUAGE';
export const ADDFORINGLANGUAGE = 'ADDFORINGLANGUAGE';
export const DELFORINGLANGUAGE = 'DELFORINGLANGUAGE';
export const DELINTERFACELANGUAGE = 'DELINTERFACELANGUAGE';
export const ADDINTERFACELANGUAGE = 'ADDINTERFACELANGUAGE';
export const GETDETAILSENTENCE  = 'GETDETAILSENTENCE ';
export const GETSENTENCE  = 'GETSENTENCE';
export const GETSENTENCEFILTER  = 'GETSENTENCEFILTER';
export const ADDSENTENCE  = 'ADDSENTENCE';
export const UPDATESENTENCE  = 'UPDATESENTENCE';
export const DELSENTENCE  = 'DELSENTENCE';
export const ADDNOTIFICATION  = 'ADDNOTIFICATION';
export const UPDATENOTIFICATION  = 'UPDATENOTIFICATION';
export const ADDTRANSLATIONSENTENSE  = 'ADDTRANSLATIONSENTENSE';
export const UPDATETRANSLATIONSENTENSE  = 'UPDATETRANSLATIONSENTENSE';
export const GETNOTIFICATION  = 'GETNOTIFICATION';
export const CHANGEPOSITION = 'CHANGEPOSITION';
export const PAGINATIONUSER = 'PAGINATIONUSER';
export const PAGINATIONSENTENCE = 'PAGINATIONSENTENCE';
export const GETSENTENCESTAT = 'GETSENTENCESTAT';
export const CHANGEINTERFACELANG = 'CHANGEINTERFACELANG';
export const GETVOCABULARYSTAT = 'GETVOCABULARYSTAT';
export const GETWORDFILTER = 'GETWORDFILTER';
export const GETGRAMMARSTAT = 'GETGRAMMARSTAT';
export const SAVERULE = 'SAVERULE';
export const GETRULE = 'GETRULE';
export const DELRULE = 'DELRULE';
export const GETDETAILRULE = 'GETDETAILRULE';
export const EDITRULE = 'EDITRULE';
export const GETRULEFILTER = 'GETRULEFILTER';
export const GETINTERFACETRANSLATION = 'GETINTERFACETRANSLATION';
export const ADDINTERFACETRANSLATION = 'ADDINTERFACETRANSLATION';
export const EDITINTERFACETRANSLATION = 'EDITINTERFACETRANSLATION';
export const GETINTERFACEFILTER = 'GETINTERFACEFILTER';
export const GETSPECIALSTATS = 'GETSPECIALSTATS';
export const GETSPECIALEVENTS = 'GETSPECIALEVENTS';
export const ADDSPECIALEVENTS = 'ADDSPECIALEVENTS';
export const EDITSPECIALEVENTS = 'EDITSPECIALEVENTS';
export const GETONESPECIALEVENTS = 'GETONESPECIALEVENTS';
export const DELETEONESPECIALEVENTS = 'DELETEONESPECIALEVENTS';
export const GETSTATICPAGESTATS = 'GETSTATICPAGESTATS';
export const ADDSTATICPAGE = 'ADDSTATICPAGE';
export const GETSTATICPAGE = 'GETSTATICPAGE';
export const GETSTATICPAGEONE = 'GETSTATICPAGEONE';
export const EDITSTATICPAGE = 'EDITSTATICPAGE';
export const DELPAGE = 'DELPAGE';
export const GETPAGEFILTER = 'GETPAGEFILTER';
export const GETEMAILTEMPLATES = 'GETEMAILTEMPLATES';
export const GETEMAILTEMPLATEONE = 'GETEMAILTEMPLATEONE';
export const EDITEMAILTEMPLATE = 'EDITEMAILTEMPLATE';
export const ADDEMAILTEMPLATE = 'ADDEMAILTEMPLATE';
export const GETSETTINGS = 'GETSETTINGS';
export const EDITSETTINGS = 'EDITSETTINGS';
export const GETCHATEVENTFILTER = 'GETCHATEVENTFILTER';
export const GETCOUPONFILTER = 'GETCOUPONFILTER';
export const PAGINATIONWORD = 'PAGINATIONWORD';
export const GETLIVESITUATION = 'GETLIVESITUATION';
export const ADDLIVESITUATION = 'ADDLIVESITUATION';
export const GETONELIVESITUATION = 'GETONELIVESITUATION';
export const DELLIVESITUATION = 'DELLIVESITUATION';
export const UPDATELIVESITUATION = 'UPDATELIVESITUATION';
export const ADDTRANSLATIONLIVESITUATION = 'ADDTRANSLATIONLIVESITUATION';
export const UPDATETRANSLATIONLIVESITUATION = 'UPDATETRANSLATIONLIVESITUATION';
export const GETSITUATIONSSTAT = 'GETSITUATIONSSTAT';
export const GETSITUATIONFILTER = 'GETSITUATIONFILTER';
export const GETSITUATIONSELECT = 'GETSITUATIONSELECT';
export const NOTIFICATION = 'NOTIFICATION';
export const NOTIFICATIONONE = 'NOTIFICATIONONE';
export const GETNOTIFICATIONSELECT = 'GETNOTIFICATIONSELECT';
export const NOTIFICATIONADD = 'NOTIFICATIONADD';
export const NOTIFICATIONUPDATE = 'NOTIFICATIONUPDATE';
export const DELLETENOTIFICATION = 'DELLETENOTIFICATION';
export const NOTIFICATIONADDTRANSLATION = 'NOTIFICATIONADDTRANSLATION';
export const NOTIFICATIONUPDATETRANSLATION = 'NOTIFICATIONUPDATETRANSLATION';
export const PAGINATI_LIV_SITUATIN = 'PAGINATI_LIV_SITUATIN';


// if(window.location.host == 'localhost:8080'){
//     ROOT_URL = 'http://api.language.dev.4-com.pro'
// }else{
//     if(window.location.host == 'admin.language.test.4-com.pro'){
//         ROOT_URL = 'http://api.language.test.4-com.pro';
//     }else{
//         ROOT_URL = 'http://api.language.dev.4-com.pro';
//     }
    // ROOT_URL = window.location.origin;
    // ROOT_URL = 'http://api.language.dev.4-com.pro';
// }



// WEBPACK FOOTER //
// ./src/actions/constant.js